<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle label="Feedback Settings" target="toggleGroupFeedback" class="mb-4" />
    <div id="toggleGroupFeedback" class="collapse row">
      <div class="col-12 mb-3 text-center">
        <div class="d-inline-block text-center">
          <StarRating :rating="course.rating" />
          <div
            class="text-center text-uppercase font-weight-bold text-primary"
          >{{ course.rating || 0 }} out of 5 ({{ course.surveys_submitted || 0 }} reviews)</div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <Field
          type="checkbox"
          name="enable_rating"
          id="cb_enable_rating"
          label="Enable ratings for this course"
          :value="!!course.enable_rating"
          :checkbox-value="1"
        />
      </div>
      <div class="col-12 mb-3">
        <Field
          type="checkbox"
          name="show_rating"
          id="cb_show_rating"
          label="Show the feedback tab in the details pane for this course"
          :value="!!course.show_rating"
          :checkbox-value="1"
        />
      </div>
      <div class="col-12 mb-3">
        <HtmlField
          name="meta[testimonials]"
          label="Testimonials"
          :value="course.testimonials"
          :hideAssetIcons="true"
        />
      </div>
      <div class="col-12 mb-3">
        <HtmlField
          name="meta[trainer_comments]"
          label="Trainer Comments"
          :value="course.trainer_comments"
          :hideAssetIcons="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true }
  }
};
</script>